export const NDR_2025_PAGE = "ndr2025";
export const SEASONAL_TAGS = "bhndr2025,bhndp2025";
